var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReportBtnPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 9.69238V6.19238H9.33326V9.69238H7.58326V4.44238H20.4166V9.69238H18.6666ZM20.7756 14.359C21.1062 14.359 21.3833 14.2472 21.6069 14.0236C21.8305 13.8 21.9423 13.5229 21.9423 13.1924C21.9423 12.8618 21.8305 12.5847 21.6069 12.3611C21.3833 12.1375 21.1062 12.0257 20.7756 12.0257C20.4451 12.0257 20.168 12.1375 19.9444 12.3611C19.7208 12.5847 19.609 12.8618 19.609 13.1924C19.609 13.5229 19.7208 13.8 19.9444 14.0236C20.168 14.2472 20.4451 14.359 20.7756 14.359ZM18.6666 22.1667V17.1859H9.33326V22.1667H18.6666ZM20.4166 23.9167H7.58326V19.25H3.25317V12.609C3.25317 11.7827 3.53551 11.09 4.10017 10.5309C4.66484 9.9719 5.35473 9.69238 6.16984 9.69238H21.83C22.6564 9.69238 23.3491 9.9719 23.9081 10.5309C24.4672 11.09 24.7467 11.7827 24.7467 12.609V19.25H20.4166V23.9167ZM22.9967 17.5V12.609C22.9967 12.2785 22.8849 12.0014 22.6613 11.7778C22.4376 11.5542 22.1606 11.4424 21.83 11.4424H6.16984C5.83928 11.4424 5.5622 11.5542 5.33859 11.7778C5.11498 12.0014 5.00317 12.2785 5.00317 12.609V17.5H7.58326V15.4359H20.4166V17.5H22.9967Z",
    fill: "#00559E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportBtnPrint);
export default __webpack_public_path__ + "static/media/report_btn_print.c2f5ff2479c1243188bcbb8ff2d893a7.svg";
export { ForwardRef as ReactComponent };